import React, {Component} from 'react';
import {dispatch} from 'react-redux';
import {Grid, Row, Jumbotron} from 'react-bootstrap';
import veri_sign from '../logo-verisign.png';

import inituit_logo from '../intuit-logo.png';
import {HashLink as Link} from 'react-router-hash-link';
import TrustEBrandLogo from "./truste-brand-logo";


class SignOut extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: true
        };
    }

    render() {

        return (

            <div>
                <Grid>
                    <Jumbotron className="not-logged-in">
                        <div>
                            <h5><font color="green"><b>You are signed out.</b></font></h5>
                            <br/>
                        </div>
                        <div>
                            <font face="verdana" size="4">Your tax preparer will follow up with you if
                                necessary<br/></font>
                            <br/>
                        </div>
                        <div>
                            <font face="verdana" size="4">Forget something? <Link to="sign_in"><u><b>Sign
                                in</b></u></Link> again</font>
                        </div>
                    </Jumbotron>
                    <Row>
                        <table className="logo-table">
                            <tbody>
                            <td className="left-brand-logo">
                                <img src={inituit_logo} alt="logo" width="120" height="40"/> <br/>
                                <Link to="/tnc" target="_blank"><font size="1.9" color="blue">Terms of
                                    Service</font></Link> |<a href="https://quickbooks.intuit.com/r/"
                                                              target="_blank"><font color="blue" size="1.75">
                                Privacy</font></a> <br/>
                                <font color="#00008b" size="1.75"> © 2019 Intuit Inc. All rights reserved.</font><br/>
                            </td>
                            <td className="right-brand-logo">
                                <TrustEBrandLogo />
                                <a href="https://sealinfo.verisign.com/splash?lang=en&dn=tax%2Design%2Eintuit%2Ecom&form%5Ffile=fdf%2Fsplash%2Efdf"
                                   target="_blank"> <img src={veri_sign} alt="logo" width="130" height="60"/></a>
                            </td>
                            </tbody>
                        </table>
                    </Row>
                </Grid>
            </div>
        );
    }
}


export default SignOut;
